import React from 'react';

import Joyride, { CallBackProps, STATUS, Step } from 'react-joyride';
import { useTheme } from 'styled-components';

/**
 * Tour do simulador, no molde do simulador de referência da task (MV2-2006). Usa a mesma
 * react-joyride 2.5.5 do tutorial da Interoperabilidade (ver o comentário de lá sobre a versão).
 * Os passos são todos da mesma tela: não precisa da espera por alvo que o de lá tem.
 */
export const SIMULATOR_TOUR_STEPS: Step[] = [
  {
    target: '#sim-energy',
    title: 'Entrada de energia',
    content:
      'Corrente disponível para o grupo. No Geral ela vale para a soma de todos os conectores; no Por Fases, para cada fase.',
    disableBeacon: true,
  },
  {
    target: '#sim-meter',
    title: 'Carga externa',
    content:
      'O que o medidor enxerga fora dos carregadores (prédio, iluminação, chuveiros), por fase. Desligue a comunicação para ver o modo conservador.',
    disableBeacon: true,
  },
  {
    target: '#sim-stations',
    title: 'Vagas e estações',
    content:
      'Coloque ou tire carros clicando na vaga. Para cada estação, escolha a ligação (rotação de fases) e quantas fases o carro puxa.',
    disableBeacon: true,
  },
  {
    target: '#sim-results',
    title: 'Resultado dos dois algoritmos',
    content:
      'Corrente e potência de cada carro, e o uso contra o limite. Verde: dentro do limite. Vermelho: o mínimo de 6 A por carro passou do limite.',
    disableBeacon: true,
  },
  {
    target: '#sim-compare',
    title: 'Comparação',
    content: 'Quanto o Por Fases entrega a mais que o Geral no mesmo cenário.',
    disableBeacon: true,
  },
];

type SimulatorTourProps = {
  run: boolean;
  onClose: () => void;
};

export const SimulatorTour = ({ run, onClose }: SimulatorTourProps) => {
  const theme = useTheme() as { primary?: string } | undefined;

  const handleCallback = ({ status }: CallBackProps) => {
    if (([STATUS.FINISHED, STATUS.SKIPPED] as string[]).includes(status)) {
      onClose();
    }
  };

  return (
    <Joyride
      run={run}
      steps={SIMULATOR_TOUR_STEPS}
      continuous
      showSkipButton
      scrollToFirstStep
      callback={handleCallback}
      locale={{ back: 'Voltar', close: 'Fechar', last: 'Concluir', next: 'Próximo', skip: 'Pular' }}
      styles={{
        // Acima do Modal do antd (1000)
        options: { zIndex: 10000, primaryColor: theme?.primary || '#015989' },
        tooltip: { borderRadius: 16 },
      }}
    />
  );
};
